import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=376e19fa&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376e19fa')) {
      api.createRecord('376e19fa', component.options)
    } else {
      api.reload('376e19fa', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=376e19fa&", function () {
      api.rerender('376e19fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C6swR9VoxwtM/JS/videoIframe.vue"
export default component.exports